import { Text } from '@visx/text';
import cn from 'classnames';
import React, { FC, Fragment, useMemo } from 'react';

import { Donut, DonutLegendType } from '@.partials';
import { DEFAULT_ANALYTICS_CHART_COLORS } from '@/Components/Partials/Analytics/constants';
import { ChartDatasetValues } from '@/Types/analytics/chartsTypes';

import S from './styles.module.scss';

type AgeChartProps = {
    data: ChartDatasetValues;
    mini?: boolean;
};

export const AgeChart: FC<AgeChartProps> = ({ data, mini = false }) => {
    const donutData = useMemo(() => {
        return data.map((datasetItem, index) => ({
            value: datasetItem.value,
            label: datasetItem.label,
            color: DEFAULT_ANALYTICS_CHART_COLORS[index],
            pct: datasetItem.pct,
        }));
    }, [data]);

    const legend = useMemo<DonutLegendType>(() => {
        return {
            columns: 2,
            legendItems: donutData.map(({ color, value, label, pct }) => ({
                color,
                label: (
                    <Fragment key={label}>
                        <span>{label}</span>
                        <span>
                            {pct}% ({value})
                        </span>
                    </Fragment>
                ),
            })),
        };
    }, [donutData]);

    const contentCenterData = useMemo(() => donutData.reduce((acc, obj) => acc + obj.value, 0), [donutData]);

    const ContentCenter = (
        <Text fontFamily="DM Sans" fontWeight={500} fontSize={20} lineHeight={26} fill="#000" textAnchor="middle" verticalAnchor="middle">
            {contentCenterData}
        </Text>
    );

    return (
        <div>
            <h3 className={cn(S.title, { [S['title-mini']]: mini })}>Age</h3>
            <div className={cn(S.age_chart, { [S['age_chart-mini']]: mini })}>
                {mini ? (
                    <Donut data={donutData} contentCenter={ContentCenter} className={S['donut-mini']} />
                ) : (
                    <Donut data={donutData} legend={legend} contentCenter={ContentCenter} />
                )}
            </div>
        </div>
    );
};
